import React, { useEffect, useState } from 'react'
import './index.scss'
import { NOTIFICATION_MESSAGE_TYPE } from '../../constants'
import tickIcon from '../../assets/images/check-circle-filled.svg'
import warningIcon from '../../assets/images/notification-warning-filled.svg'
import errorIcon from '../../assets/images/error-filled.svg'
import infoIcon from '../../assets/images/info-circle-filled.svg'
import { useTranslation } from 'react-i18next'

export const Alert = ({
    options = null,
    isError,
    type,
    message = '',
    onAlertClose,
    setTimeout: shouldTimeout,
    timeOut,
    showAlert
}) => {
    const [isOpen, setIsOpen] = useState(showAlert)
    const [animate, setAnimate] = useState(false)
    const { t } = useTranslation(['labels', 'errors'])

    useEffect(() => {
        if (showAlert) {
            setIsOpen(true)
            setTimeout(() => setAnimate(true), 10)
        } else {
            setAnimate(false)
            setTimeout(() => setIsOpen(false), 300)
        }
    }, [showAlert])

    useEffect(() => {
        let timer
        if (shouldTimeout && isOpen) {
            timer = setTimeout(() => {
                handleClose()
            }, timeOut ? timeOut : 5000)
        }
        return () => {
            if (timer) clearTimeout(timer)
        }
    }, [isOpen, shouldTimeout, timeOut])

    const handleClose = () => {
        setAnimate(false)
        setTimeout(() => {
            setIsOpen(false)
            if (onAlertClose) onAlertClose()
        }, 300)
    }

    if (!isOpen) return null

    let icon = tickIcon
    if (
        isError ||
        (type && type === NOTIFICATION_MESSAGE_TYPE.ERROR)
    ) {
        icon = errorIcon
    } else if (type && type === NOTIFICATION_MESSAGE_TYPE.INFO) {
        icon = infoIcon
    } else if (type && type === NOTIFICATION_MESSAGE_TYPE.WARNING) {
        icon = warningIcon
    }

    return (
        <div className={`common-alert-wrapper my-3${animate ? ' show-alert' : ''}`}>
            <img src={icon} alt={type || 'Success'} className='alert-icon' />
            <div className='alert-body-wrapper'>
                <div className='alert-body-content'>
                    {message.includes('<br>') ? (
                        <p dangerouslySetInnerHTML={{ __html: message }}></p>
                    ) : (
                        <p>{message}</p>
                    )}
                </div>
                <div className='alert-dismiss-button' onClick={handleClose}>{t("COMMON.DISMISS")}</div>
            </div>
        </div>
    )
}